import { Text } from 'ab-uitools-legacy'
import './index.scss'

const Label = (props) => {
  const { text, required, className } = props
  return (
    <Text className={`${className ? className : ''} input-label`}>
      <>
        {text}
        {required ? <span className="label_important">*</span> : null}
      </>
    </Text>
  )
}
export default Label
